import { useEffect, useState } from 'react';
import { calculatePercent } from '../utils';
import PropTypes from '../../../utils/propTypes';

export const SimpleBar = ({ width, values }) => {
  const border = {
    outline: '1px solid #D3D3D3',
  };

  const [percent, setPercent] = useState(0);

  useEffect(() => {
    setPercent(calculatePercent(values[1], values[0]));
  }, [values]);

  return (
    <div className="card-wrapper-table" style={{ minWidth: width }}>
      <span style={{ width: '0%', display: 'block' }}></span>
      <div
        className="total-progress"
        style={{
          display: 'flex',
          width: '100.0%',
          fontSize: '15px',
          // fontWeight: '600',
          padding: 0,
          ...border,
        }}
      >
        <div
          style={{
            width: `${percent > 100 ? 100 : percent}%`,
            backgroundColor: '#ff0000',
            display: 'grid',
            animationDuration: `${(percent > 100 ? 100 : percent) / 50}s`,
          }}
        >
          <span
            className="percent-text"
            style={{
              textShadow: '0px 1px 4px #23430c',
            }}
          >{`${percent}%`}</span>
        </div>
      </div>
    </div>
  );
};

SimpleBar.propTypes = {
  width: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.number).isRequired,
};

SimpleBar.defaultProps = {
  width: undefined,
};
